import type { ActorLookup } from "@istari-frontend/notifications/model";

import type { UserDisplayName } from "~/user/feature/use-user-display-names";
import { UNKNOWN_USER_DISPLAY_NAME } from "~/user/utils/format-user-name";

export const LOADING_ACTOR_LOOKUP: ActorLookup = { status: "loading" };
export const UNKNOWN_ACTOR_LOOKUP: ActorLookup = { status: "resolved", displayName: UNKNOWN_USER_DISPLAY_NAME };

export function toActorLookup(user: UserDisplayName | undefined, isIdLoading: boolean): ActorLookup {
  if (user?.status === "resolved") {
    return { status: "resolved", displayName: user.displayName ?? UNKNOWN_USER_DISPLAY_NAME };
  }
  if (isIdLoading || user?.status === "loading") return LOADING_ACTOR_LOOKUP;
  return UNKNOWN_ACTOR_LOOKUP;
}
